import { getBaseUrl } from '~/server/logic/url';
import { createUrl } from './url/create-url';

export const SLACK_APP_CLIENT_ID = '5391925254967.4774314435414';

export const SLACK_APP_SETTINGS_URL =
  'https://stablygroup.slack.com/marketplace/A04NS98CTC6-stably?next_id=0&tab=settings';

function normalizeOrigin(value: string): string {
  const trimmed = value.trim().replace(/\/+$/, '');
  if (!trimmed) {
    return trimmed;
  }

  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    try {
      return new URL(trimmed).origin;
    } catch {
      return trimmed;
    }
  }

  const scheme = trimmed.includes('localhost') ? 'http://' : 'https://';
  try {
    return new URL(`${scheme}${trimmed}`).origin;
  } catch {
    return `${scheme}${trimmed}`;
  }
}

export function getRedirectUrl(projectId: string, origin = getBaseUrl()) {
  return `${normalizeOrigin(origin)}/project/${projectId}/slack/redirect`;
}

export const getSlackAuthUrl = ({ projectId, state, origin }: { projectId: string; state: string; origin?: string }) =>
  createUrl('https://slack.com/oauth/v2/authorize', {
    client_id: SLACK_APP_CLIENT_ID,
    scope: ['incoming-webhook', 'chat:write'].join(','),
    state,
    // TODO:
    // This needs to also be manually added via the slack app's management page
    redirect_uri: getRedirectUrl(projectId, origin),
  });
